export const clss = ( ...args : (string|undefined)[] ) : string =>
	args.filter( c => c !== undefined).map( c => c.trim() ).filter( c => c !== '' ).join( ' ' );
